import { Canvas } from "./Canvas";

export class GameStats {
  private _livesLeft: number = 10;
  private _moneyLeft: number = 500;
  private _canvas: Canvas;
  constructor(canvas: Canvas) {
    this._canvas = canvas;
  }

  public get livesLeft(): number {
    return this._livesLeft;
  }

  public set livesLeft(livesLeft: number) {
    this._livesLeft = livesLeft;
  }

  public get moneyLeft(): number {
    return this._moneyLeft;
  }

  public set moneyLeft(moneyLeft: number) {
    this._moneyLeft = moneyLeft;
  }
}
